export default __webpack_public_path__ + "static/media/436.6087b232.png";